import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import './app/globals/scss/commonStyle.scss';
import { PreviousRouteProvider } from './app/guards';

if (process.env.NODE_ENV === 'production') {
  console.log = () => { }; // Disable console.log in production
  console.warn = () => { }; // Optionally disable warnings
  console.error = () => { }; // Optionally disable errors
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // <StrictMode >
    <BrowserRouter basename='/'>
      <PreviousRouteProvider>
        <App />
      </PreviousRouteProvider>
    </BrowserRouter>
  // </StrictMode>
);

reportWebVitals();
